import {SnackbarNotificationType} from '../../../../shared/components/snackbar/model';
import {apiUrls} from '../../../../shared/constants/urls';
import {httpService, HttpWrapperOptions} from '../../../../shared/httpWrapper';
import {
  MessageFrom,
  PostProcessPromptRequestPayload,
  PostProcessPromptResponsePayload,
} from '../../../../shared/models/api';
import {GetChatHistoryResponsePayload} from '../../../../shared/models/api/getChatHistoryResponsePayload';
import {getApiRoute} from '../../../../shared/pipes';
import {chatbotActions} from '../../../reducers/socialSupport/chatbot';
import {AppThunk} from '../../index';
import {addNotification} from '../../snackbar';

export const getChatHistory = (): AppThunk => {
  return async (dispatch) => {
    try {
      const response = await httpService.get<GetChatHistoryResponsePayload>(
        getApiRoute(apiUrls.getChatHistory),
        new HttpWrapperOptions().ThrowException(true).Errors(false),
      );

      dispatch(chatbotActions.setChatbotError(false));
      dispatch(chatbotActions.setMessages(response));
    } catch (error) {
      dispatch(chatbotActions.setChatbotError(true));
    }
  };
};

export const postProcessPrompt = (data: PostProcessPromptRequestPayload): AppThunk => {
  return async (dispatch) => {
    const sentAt = data?.sentAt ?? new Date().toISOString();

    try {
      dispatch(chatbotActions.setMessages({text: data.prompt, sentAt}));

      dispatch(chatbotActions.setChatbotLoading(true));

      const response = await httpService.post<PostProcessPromptResponsePayload>(
        getApiRoute(apiUrls.postProcessPrompt),
        {...data, sentAt},
        new HttpWrapperOptions().ThrowException(true).Errors(false),
      );

      dispatch(chatbotActions.setMessages({...response, role: MessageFrom.ASSISTANT}));
    } catch (e) {
      dispatch(chatbotActions.setChatbotError(true));
      dispatch(
        addNotification({
          message: 'Не удалось отправить сообщение',
          type: SnackbarNotificationType.Error,
        }),
      );
    } finally {
      dispatch(chatbotActions.setChatbotLoading(false));
    }
  };
};
